<section [formGroup]="formGroup"
         class="mat-typography signalR-section">
    <h4 translate>settings_scalability_signalR</h4>

    <mat-slide-toggle (change)="onSignalRToggle($event)"
                      [formControlName]="ScalabilityControl.signalR"
                      [attr.data-cy]="'signalR-toggle'">
        {{ 'settings_scalability_signalR_enabled' | translate }}
    </mat-slide-toggle>

    <div *ngLet="formGroup.get(ScalabilityControl.signalRConfig) as signalRConfigFormGroup"
         [formGroup]="signalRConfigFormGroup"
         class="signalR-options-container">

        <div class="mat-checkbox-group-container">
            <mat-checkbox #webSocketCheckbox
                          [formControlName]="ScalabilitySignalRControl.webSocketTransport"
                          [attr.data-cy]="'websocket-checkbox'">
                {{ 'settings_scalability_signalR_webSocket' | translate }}
            </mat-checkbox>

            <mat-checkbox [formControlName]="ScalabilitySignalRControl.serverSentEventsTransport"
                          [attr.data-cy]="'server-events-checkbox'">
                {{ 'settings_scalability_signalR_serverSentEvents' | translate }}
            </mat-checkbox>

            <mat-checkbox [formControlName]="ScalabilitySignalRControl.longPollingTransport"
                          [attr.data-cy]="'long-polling-checkbox'">
                {{ 'settings_scalability_signalR_longPolling' | translate }}
            </mat-checkbox>

            <mat-error *ngIf="signalRConfigFormGroup.hasError('invalidSelection')"
                       translate>
                settings_scalability_form_no_option_selected
            </mat-error>
        </div>

        <div *ngIf="!webSocketCheckbox.checked"
             class="signalR-options-info">
            <mat-hint translate>
                settings_scalability_signalR_webSocket_warn
            </mat-hint>
        </div>
    </div>
</section>
